/**
 * Recall jump navigation — clone into the article sidebar.
 * The source stays inside the Shopify section so theme editor updates
 * (every keystroke) can rewrite it. Moving that node made the nav vanish.
 */
(function () {
  const SECTION_NAV_SELECTOR = '.shopify-section.cc-dimark-recall-jump-nav [data-recall-jump-nav]';
  const MOUNT_SELECTOR = '[data-recall-nav-mount]';
  const NAV_SELECTOR = '[data-recall-jump-nav]';

  function slugify(text, index) {
    const base = (text || '').trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
    return base || `recall-image-${index + 1}`;
  }

  function collectRecallImages(article) {
    const targets = [];
    const content = article.querySelector('.article__content');
    const heroWrap = article.querySelector('[data-recall-hero-image]');
    const heroImg = heroWrap?.querySelector('img');

    if (heroImg) {
      if (!heroImg.id) {
        heroImg.id = `recall-${slugify(heroImg.getAttribute('alt'), 0)}`;
      }
      heroImg.setAttribute('tabindex', '-1');
      targets.push(heroImg);
    }

    if (content) {
      content.querySelectorAll('img').forEach((img, index) => {
        if (!img.id) {
          const label = img.getAttribute('alt')?.trim() || `notice-${targets.length + index + 1}`;
          img.id = `recall-${slugify(label, targets.length + index)}`;
        }
        img.setAttribute('tabindex', '-1');
        targets.push(img);
      });
    }

    return targets;
  }

  function scrollToImage(img, nav) {
    const headerOffset = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 80;
    const top = img.getBoundingClientRect().top + window.scrollY - headerOffset - 16;
    window.scrollTo({ top, behavior: 'smooth' });
    img.focus({ preventScroll: true });
    nav.querySelectorAll('.article-recall-nav__btn').forEach((el) => el.classList.remove('is-active'));
  }

  function clearMount() {
    const mount = document.querySelector(MOUNT_SELECTOR);
    if (!mount) return;
    mount.querySelectorAll(NAV_SELECTOR).forEach((el) => el.remove());
  }

  function bindNavClicks(nav, images) {
    nav.addEventListener('click', (event) => {
      const btn = event.target.closest('[data-recall-target-index]');
      if (!btn || !nav.contains(btn)) return;

      const index = Number(btn.getAttribute('data-recall-target-index')) || 1;
      const img = images[index - 1] || images[images.length - 1];
      if (!img) return;

      scrollToImage(img, nav);
      btn.classList.add('is-active');
    });
  }

  function initRecallNav() {
    const article = document.querySelector('.js-article--recall');
    const mount = document.querySelector(MOUNT_SELECTOR);
    const sourceNav = document.querySelector(SECTION_NAV_SELECTOR);

    clearMount();

    if (!article || !mount || !sourceNav) {
      article?.classList.remove('article--recall-has-nav');
      return;
    }

    const nav = sourceNav.cloneNode(true);
    nav.removeAttribute('id');
    mount.appendChild(nav);

    const images = collectRecallImages(article);
    if (images.length) {
      bindNavClicks(nav, images);
    }

    article.classList.add('article--recall-has-nav');
  }

  if (window.__dimarkRecallNavRefresh) {
    window.__dimarkRecallNavRefresh();
    return;
  }

  window.__dimarkRecallNavRefresh = initRecallNav;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRecallNav);
  } else {
    initRecallNav();
  }

  document.addEventListener('shopify:section:load', initRecallNav);
  document.addEventListener('shopify:section:reorder', initRecallNav);
  document.addEventListener('shopify:block:select', initRecallNav);

  document.addEventListener('shopify:section:unload', (event) => {
    if (!event.target?.classList?.contains('cc-dimark-recall-jump-nav')) return;
    clearMount();
    document.querySelector('.js-article--recall')?.classList.remove('article--recall-has-nav');
  });
})();
